module.exports = __webpack_public_path__ + "img/DSCF0270.bd449c75.png";